import { render, staticRenderFns } from "./GLBViewer.vue?vue&type=template&id=25fb6465&scoped=true"
import script from "./GLBViewer.vue?vue&type=script&lang=js"
export * from "./GLBViewer.vue?vue&type=script&lang=js"
import style0 from "./GLBViewer.vue?vue&type=style&index=0&id=25fb6465&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb6465",
  null
  
)

export default component.exports